import React, { useState } from "react";
import styles from "./style/answer_carrousel.module.css";
import styles_mm from "./style/answer_matrix.module.css";
import { useLanguage } from '../../functions/setGetLanguage';


import ImgBuilder from "../../assets/ImgBuilder";
import DotsCarrousel from '../dotsCarrousel/dotsCarrousel';
import Post from "../post/post";
// import styles_post from "../post/post.module.css";

const Answer_carrousel = ({ choices_cr, choices, FunctionOnClick, carrousel, setCarrousel, variables, minSwipeDistance}) => {
  const { language } = useLanguage();

  const handleChoiceClick = (choice) => {
    // If the choice has a next property, update the carousel index
    if (choice.carrousel_action === true){
      if (choice.hasOwnProperty('store_variable')){
        const newProfile = {"selected_profile":choices_cr[carrousel].name};
        setCarrousel(0);
        choice.store_variable = newProfile
        FunctionOnClick(choice);
      }
      else{
        const current_choice = choices_cr[carrousel]
        setCarrousel(0);
        FunctionOnClick(current_choice);
      }
    }
    else{
      const newIndex = (carrousel + 1) % choices_cr.length;
      setCarrousel(newIndex);
      return
    }
  };

  // swipe
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleTouchStart = (item) => {
    setTouchEnd(null);
    setTouchStart(item.targetTouches[0].clientX);
  };

  const handleTouchMove = (item) => {
    setTouchEnd(item.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (typeof touchStart !== "number" || typeof touchEnd !== "number") return;
    const distance = touchStart - touchEnd;
    if (distance > minSwipeDistance){ 
      const newIndex = (carrousel + 1) % choices_cr.length;
      setCarrousel(newIndex);
    }
    else if (distance < -minSwipeDistance) {
      const newIndex = (carrousel - 1 + choices_cr.length) % choices_cr.length;
      setCarrousel(newIndex);
    };
  };

  return (
    <>
      <div 
        className={styles.center} 
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
          <div className={styles.carrousel}> 
              {choices_cr.map((choice, i) => (
                <Post key={i} message={choice[`text${language}`]} isPlayerPost={true} additional_class={`${styles.playerPost} ${carrousel === i ? styles.activeClassCarrousel : ''}`}
                profilePic={ImgBuilder[`${variables.selected_profile}_small`]} profileName={variables.selected_profile}/>
              ))}
          </div>
          <DotsCarrousel choices={choices_cr} carrousel={carrousel}/>
      </div>

       <div className={styles_mm.choices}>
          {choices.map((choice, i) => (
            <button
              key={i}
              className={styles_mm.choiceButton}
              onClick={() => handleChoiceClick(choice)}
            >
              {choice[`text${language}`]}
            </button>
          ))}
        </div>
    </>
  );
};

export default Answer_carrousel;
